const initSW = () => {
  if ('serviceWorker' in navigator) {
    const _sw = async () => {
      try {
        const registration = await navigator.serviceWorker.register(
          'sw.js',
          {
            scope: './',
          }
        );
        if (registration.installing) {
          console.log('Service worker installing');
        } else if (registration.waiting) {
          console.log('Service worker installed');
        } else if (registration.active) {
          console.log('Service worker active');
        }
      } catch (error) {
        console.error(`Registration failed with ${error}`);
      }
    }
    // const e = document.getElementById("container");
    // const _rs = () => {
    //   console.log("resize")
    //   e.style.transform = `scale(${innerWidth / 450},${innerHeight / 281})`;
    // }
    // window.addEventListener("orientationchange", _rs, false);
    // window.addEventListener("resize", _rs);
    _sw();
    // if (screen.lock)
    //   screen.lock("landscape");
    // setTimeout(() => {
    //   _rs();
    //   e.style.opacity = "1";
    // }, 500);
  }
};
export { initSW };